/**
 * @file ProjectsView.jsx
 * @description Proje listesi görünüm bileşeni
 *
 * Emlakjet yeni konut projeleri için grid tabanlı liste görünümü.
 * Her proje için ProjectCard bileşeni render edilir.
 *
 * @module widget/components/ProjectsView
 */

import { ProjectCard } from "./ProjectCard";

/**
 * Proje Listesi Görünüm Bileşeni
 *
 * Yeni konut projelerini responsive grid layout ile listeler.
 * search_projects_by_company tool'unun sonuçlarını gösterir.
 *
 * @component
 * @param {Object} props - Bileşen prop'ları
 * @param {Object[]} props.projects - Proje listesi
 * @param {string|number} [props.projects[].id] - Proje ID'si
 * @param {string} [props.projects[].url] - Proje URL'i
 * @param {boolean} props.isDark - Karanlık mod
 *
 * @returns {JSX.Element} Grid tabanlı proje listesi
 *
 * @example
 * <ProjectsView
 *   projects={[{ id: 1, name: "Proje A" }, { id: 2, name: "Proje B" }]}
 *   isDark={false}
 * />
 */
export function ProjectsView({ projects, isDark }) {
  return (
    <div className="p-3 sm:p-5 grid grid-cols-1 gap-3 sm:gap-4">
      {projects.map((project, index) => (
        <ProjectCard
          key={String(project?.id ?? project?.url ?? index)}
          project={project}
          isDark={isDark}
        />
      ))}
    </div>
  );
}

export default ProjectsView;
